<div fxLayout="row" fxLayoutAlign="start center">
  <div fxLayout="column">
    <form #orgForm>
      <mat-form-field class="inspect-review-org-form" color="accent" appearance="outline" subscriptSizing="dynamic">
        <mat-select [(value)]="selected" panelClass="selectPopupFull">
          <mat-option (onSelectionChange)="changeOrg($event)" [value]="'all'">General Queue</mat-option>
          @for (org of orgList; track org) {
            <mat-option [value]="org" (onSelectionChange)="changeOrg($event)"> {{ org.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  @if (pendingReviewCount >= 0) {
    <mat-chip-listbox fxShow="false" fxShow.gt-xs fxLayout="column">
      <mat-chip [ngClass]="age > thresholdDuration ? 'inspect-review-urgent-chip' : 'inspect-review-chip'" matTooltip="Inspect Pending Reviews -- Oldest Incomplete Review">
        <mat-icon matChipAvatar svgIcon="inspect" class="material-icons"></mat-icon>
        <ng-container>{{ pendingReviewCount }} - {{ age | conciseDuration }}</ng-container>
      </mat-chip>
    </mat-chip-listbox>
  }
</div>
